import connect from 'components/Shared/connect';
import { CategoryLink } from 'components/Shared/CategoryLink';
import { NO_ELEMENT } from 'utils';
import { isMobile } from 'components/Shared/responsive';
import { Section } from 'components/Section';
import { Cell, Grid } from 'components/Grid';
import { SectionBlock } from 'models/SectionBlock';
import { PopularCategoriesBlock } from 'models/PopularCategoriesBlock';

interface MergedProps extends PopularCategoriesBlock {
  isMobile: boolean;
}

export const Categories = connect<MergedProps, SectionBlock>(state => ({
  isMobile: isMobile(state)
}))(({ categories, isMobile, title, ...props }: MergedProps) => {
  if (!categories) {
    return NO_ELEMENT;
  }

  return (
    <Section {...props} title={<h1>{title}</h1>}>
      <Grid huge="8" desktop="6" large="5" tablet="4" phone="3">
        {categories.map(item => (
          <Cell key={item.url}>
            <CategoryLink
              appearance={isMobile ? 'tertiary' : 'primary'}
              title={item.title}
              isPopular={item.showPopularTag}
              categoryUrl={item.url}
              image={item.image}
            />
          </Cell>
        ))}
      </Grid>
    </Section>
  );
});
